// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__36_IF","header":"PatientQuestionnaire_header__7BkSU","info":"PatientQuestionnaire_info__1d_oz"};